import React, { Component } from 'react';
import { connect } from 'react-redux';
import Table from '../UI/Table/Table';
import Blank from '../../hoc/Blank/Blank';
import * as actions from '../../store/actions/index';
import ReactInterval from 'react-interval';

class LogViewer extends Component {
 
  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.onGetLog();
  }

    render() {
        if (this.props.mulchLog) {            
            let pl = "5px";
            var data = [];
            for (let k in this.props.mulchLog) {
                let hightlight = false;
                let entry = this.props.mulchLog[k];
                if (entry.message.toLowerCase().indexOf('removed') !== -1) {
                    hightlight = true;
                }
                data.push({
                    oid: entry.logId,highlight: hightlight, data: [
                        {
                            value: entry.logId,
                            style: { paddingLeft: pl }
                        },
                        {
                            value: entry.logDate,
                            style: { paddingLeft: pl }
                        },
                        {
                            value: entry.message,
                            style: { paddingLeft: pl }
                        }
                    ]
                }
                )
            }



            var header = [
                {
                    name: "Id",
                    style: { paddingLeft: pl }
                },
                {
                    name: "Date",
                    style: { paddingLeft: pl }
                },
                {
                    name: "Message",
                    style: { paddingLeft: pl }
                }
            ];


            return (

                <Blank>
                    <ReactInterval timeout={10000} enabled={true}
          callback={() => this.props.onGetLog()} /> 
                    <Table header={header} data={data}></Table>
                </Blank>
            );
        }
        else {
            return (<Blank></Blank>);
        }
    }

}


const mapStateToProps = state => {
  return {
    mulchLog: state.orders.mulchLog
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetLog: () => dispatch(actions.getLog())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LogViewer);


// WEBPACK FOOTER //
// ./src/components/LogViewer/LogViewer.js